import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {AccountModel} from "../../models/account.model";
import {SiteFiltersType} from "../../../../commons/types/site-filters.type";

@Component({
  standalone: false,
  selector: 'app-shipper-account-link',
  templateUrl: './shipper-account-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShipperAccountLinkComponent {

  @Input() account: AccountModel;
  @Input() user: any;
  @Input() isAllowCopyButton: boolean;
  @Input() isShowFilterByButton: boolean;

  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public isShowCopyBtn: boolean = false;

  constructor() {
  }

}
